'use client';

import { ReactNode } from 'react';
import QueryProvider from './query-provider';
import AmplifyClientSideConfiguration from '@/app/amplify-cognito-config';

export default function MainLayoutProvider({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AmplifyClientSideConfiguration />
      {children}
    </QueryProvider>
  );
}
